import { fetchSectionResults, handleSectionResponse } from '../shared/singleSectionSearch.js';
import { renderPagination } from '../shared/pagination.js';
import { elements } from './elements.js';
import { pgQueryParam, addClass, removeClass, hiddenClass } from '../../../config.js';
import { getQueryParam, updateQueryString } from '../shared/utils.js';

const onPageLinkClick = (page) => {
    updateQueryString({ [pgQueryParam]: page });
    fetchResults(page);
};

export const fetchResults = (page = parseInt(getQueryParam(pgQueryParam)) || 1) => {
    // Loading skeletons
    removeClass(elements.loadingSkeletons, hiddenClass);
    addClass(elements.resultsContainer, hiddenClass);

    fetchSectionResults(
        'search/funding-decisions',
        elements,
        page,
        (pagination) => renderPagination(pagination, onPageLinkClick),
        (response, resultsContainer) => {
            addClass(elements.loadingSkeletons, hiddenClass);
            removeClass(elements.resultsContainer, hiddenClass);

            handleSectionResponse(response, resultsContainer, elements.noResultsContainer, 'past-funding-result-template', (row, decision) => {
                row.querySelector('.js-result-year').textContent = decision.year;
                row.querySelector('.js-result-title').textContent = decision.title;
                row.querySelector('.js-result-alias').textContent = decision.alias;
                row.querySelector('.js-result-funding-type').textContent = decision.fundingType;
                row.querySelector('.js-result-amount').textContent = decision.amount;

                const keyPeopleContainer = row.querySelector('.js-result-key-people');
                if (keyPeopleContainer) {
                    const keyPersonTemplateClasses = keyPeopleContainer.querySelector('.js-result-key-people-person').classList;

                    keyPeopleContainer.innerHTML = ''; // Clear existing content

                    decision.keyPeople.forEach(person => {
                        const button = document.createElement('button');
                        button.classList.add(...keyPersonTemplateClasses);
                        button.textContent = person;
                        keyPeopleContainer.appendChild(button);
                    });
                }
            });
        }
    );
};
